import { useMutation, useQuery } from "@tanstack/react-query";

import { useAppState } from "../../../../../context/StateContext";
import { Filters, Searches } from "../../../../../models/shipeezi.table";
import { Container } from "../../../../../models/shipment.container";
import ShipmentContainerInfoService from "../../../../../services/shipment.container.info.service";
import { ContainerKeys } from "../../../../../util/queries";

const CACHE_TIME = 60 * 60 * 1000; // 1 hour

const useAction = () => {
  const { currentUser } = useAppState();

  const getAllContainers = (
    page: number = 1,
    pageSize: number = 20,
    searches?: Searches,
    filters?: Filters
  ) => {
    return useQuery({
      queryKey: ContainerKeys.getAndCountAll([page, pageSize, searches, filters]),
      queryFn: async () => {
        const response = await ShipmentContainerInfoService.getAndCountAll({
          page,
          pageSize,
          searchByOr: searches && searches.length > 0 ? JSON.stringify(searches) : "",
          companyId: currentUser?.companyId,
          ...filters,
        });

        return response?.data;
      },
      enabled: !!currentUser?.id,
      staleTime: 2 * 60 * 1000, // 2 minutos
      cacheTime: CACHE_TIME,
    });
  };

  interface UpdateContainerProps {
    id: number;
    data: Container;
  }

  const useUpdateContainer = () => {
    return useMutation({
      mutationKey: ContainerKeys.save(),
      mutationFn: ({ id, data }: UpdateContainerProps) => {
        return ShipmentContainerInfoService.update(id, data);
      },
      retry: 0,
      networkMode: "online",
    });
  };

  return {
    getAllContainers,
    useUpdateContainer,
  };
};

export default useAction;
